/**
 * Vehicle list actions
 */
export enum VehicleListActionEnum {
	/**
	 * Checks availability of the vehicles
	 */
	CHECK_AVAILABILITY = 'check_availability',

	/**
	 * Sets the category of the vehiles
	 */
	SET_CATEGORY = 'set_category',

	/**
	 * Sets the allocation of the vehicles
	 */
	SET_ALLOCATION = 'set_allocation',
}
